import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import projects from './component/projectData';
import ProjectCard from "./component/ProjectCard";
import projectStyle from "./projectStyle";
import ProjectCarousel from "./component/ProjectCarousel";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import History from "./component/History/History";
import CompanyVision from "./component/CompanyVision/CompanyVision";
import OurVision from "./component/OurVision";

//Project section
const Project = () => {
  const classes = projectStyle();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeSection, setActiveSection] = useState(null);

  //Toggle visibility of details of each card & ensure only one section is shown at a time
  const toggleSection = (section) => {
    setActiveSection((prev) => (prev === section ? null : section));
  };


  return (
  <>
    <Box id= "project" className={classes.container}>

      {/* Section Header */}
      <Typography variant="h4" className={classes.header}>
        From Past to Future
      </Typography>

      <Typography variant="body1" className={classes.paragraph}>
        This section explores the journey of Paketposthalle, from its historical roots to its architectural modern transformation.
        It highlights the heritage of the hall, the design concepts by Herzog & de Meuron, and the innovative vision of our team in shaping its future.
        Discover how past, present, and future come together in a dynamic new design.
      </Typography>

      {/* Project Cards */}
      {isMobile ? (
        <ProjectCarousel
          projects={projects}
          toggleSection={toggleSection}/>
      ) : (
        <Box className={classes.cardsContainer}>
          {projects.map((project, index) => (
            <ProjectCard
              key={index}
              project={project}
              toggleDetails={() => toggleSection(
                index === 0 ? "history"
                : index === 1 ? "vision"
                : index === 2 ? "ourVision"
                : null
              )}
            />
          ))}
        </Box>
      )}
    </Box>

    {/* Hidden Details Sections */}
    <Box className={classes.transitionContainer}>
        {activeSection === "history" && <History onClose={() => toggleSection(null)} />}
        {activeSection === "vision" && <CompanyVision onClose={() => toggleSection(null)} />}
        {activeSection === "ourVision" && <OurVision onClose={() => toggleSection(null)} />}
      </Box>
    </>
  );
};

export default Project;